__turbopack_context__.v({
  "about": "automotive-module__-FEvLa__about",
  "aboutGrid": "automotive-module__-FEvLa__aboutGrid",
  "bannerFallback": "automotive-module__-FEvLa__bannerFallback",
  "bannerMedia": "automotive-module__-FEvLa__bannerMedia",
  "campaign": "automotive-module__-FEvLa__campaign",
  "card": "automotive-module__-FEvLa__card",
  "cardBody": "automotive-module__-FEvLa__cardBody",
  "cardBottom": "automotive-module__-FEvLa__cardBottom",
  "cardMedia": "automotive-module__-FEvLa__cardMedia",
  "categories": "automotive-module__-FEvLa__categories",
  "commercial": "automotive-module__-FEvLa__commercial",
  "commercialRow": "automotive-module__-FEvLa__commercialRow",
  "container": "automotive-module__-FEvLa__container",
  "darkButton": "automotive-module__-FEvLa__darkButton",
  "description": "automotive-module__-FEvLa__description",
  "detailButton": "automotive-module__-FEvLa__detailButton",
  "empty": "automotive-module__-FEvLa__empty",
  "eyebrow": "automotive-module__-FEvLa__eyebrow",
  "favorite": "automotive-module__-FEvLa__favorite",
  "favoritesLink": "automotive-module__-FEvLa__favoritesLink",
  "filterGrid": "automotive-module__-FEvLa__filterGrid",
  "header": "automotive-module__-FEvLa__header",
  "headerActions": "automotive-module__-FEvLa__headerActions",
  "headerRow": "automotive-module__-FEvLa__headerRow",
  "heroActions": "automotive-module__-FEvLa__heroActions",
  "home": "automotive-module__-FEvLa__home",
  "identity": "automotive-module__-FEvLa__identity",
  "identityLocation": "automotive-module__-FEvLa__identityLocation",
  "identityName": "automotive-module__-FEvLa__identityName",
  "identityText": "automotive-module__-FEvLa__identityText",
  "imageButton": "automotive-module__-FEvLa__imageButton",
  "institutionalVerification": "automotive-module__-FEvLa__institutionalVerification",
  "loadMore": "automotive-module__-FEvLa__loadMore",
  "menuToggle": "automotive-module__-FEvLa__menuToggle",
  "navigation": "automotive-module__-FEvLa__navigation",
  "navigationOpen": "automotive-module__-FEvLa__navigationOpen",
  "oldPrice": "automotive-module__-FEvLa__oldPrice",
  "outlineButton": "automotive-module__-FEvLa__outlineButton",
  "platformHeader": "automotive-module__-FEvLa__platformHeader",
  "price": "automotive-module__-FEvLa__price",
  "primaryButton": "automotive-module__-FEvLa__primaryButton",
  "queryLabel": "automotive-module__-FEvLa__queryLabel",
  "reference": "automotive-module__-FEvLa__reference",
  "searchHeading": "automotive-module__-FEvLa__searchHeading",
  "searchPanel": "automotive-module__-FEvLa__searchPanel",
  "searchRow": "automotive-module__-FEvLa__searchRow",
  "section": "automotive-module__-FEvLa__section",
  "sectionHeading": "automotive-module__-FEvLa__sectionHeading",
  "shareButton": "automotive-module__-FEvLa__shareButton",
  "specs": "automotive-module__-FEvLa__specs",
  "srOnly": "automotive-module__-FEvLa__srOnly",
  "status": "automotive-module__-FEvLa__status",
  "textButton": "automotive-module__-FEvLa__textButton",
  "vehicleGrid": "automotive-module__-FEvLa__vehicleGrid",
  "vehicleIdentity": "automotive-module__-FEvLa__vehicleIdentity",
});
